/**
 * @generated SignedSource<<7a4ca59cb764ba9ad44873c285474a6b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAppraisalInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type appraisalDrawerDeleteMutation$variables = {|
  input: DeleteAppraisalInput,
|};
export type appraisalDrawerDeleteMutation$data = {|
  +deleteAppraisal: ?{|
    +deletedAppraisalId: ?string,
  |},
|};
export type appraisalDrawerDeleteMutation = {|
  response: appraisalDrawerDeleteMutation$data,
  variables: appraisalDrawerDeleteMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAppraisalPayload",
    "kind": "LinkedField",
    "name": "deleteAppraisal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAppraisalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "appraisalDrawerDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appraisalDrawerDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b1d5b71f74bbb865715feebbde3a6b80",
    "id": null,
    "metadata": {},
    "name": "appraisalDrawerDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation appraisalDrawerDeleteMutation(\n  $input: DeleteAppraisalInput!\n) {\n  deleteAppraisal(input: $input) {\n    deletedAppraisalId\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "bc2cc871309288058aa246f8fa69076b";

export default node;
